// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/common/layout/Layout';

// Pages 
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import AdminProfessors from './pages/admin/AdminProfessors';
import AdminStudents from './pages/admin/AdminStudents';
import ProfessorCourses from './pages/Prof/ProfessorCourses';
import ProfilePage from './pages/Auth/ProfilePage';
import MyCourses from './pages/Student/MyCourses';
import AllCourses from './pages/admin/AllCourses';
import AddPortfolio from './pages/admin/AddPortfolio';
import AdminCourses from "./pages/admin/AdminCourses"
import AllCoursesPublic from "./pages/PublicPages/AllCoursesPublic";
import PortfolioList from './pages/admin/PortfolioList';
import ProtectedRoute from './ProtectedRoutes/ProtectedRoute';
import EmailForm from './components/modals/EmailForm';
import AAAKKK from './pages/AAAKKK';
import ServiceRoutes from "./pages/admin/ServiceRoutes"
import AdminCoursesDelete from './pages/admin/AdminCoursesDelete';
import PortfolioP from "./components/sections/LandingPAge/Portfolio"
import CourseDetailsPage from './pages/PublicPages/CourseDetailsPage';
import ProfStudentsPage from './pages/Prof/ProfStudentsPage';
import AddCourseTimeline from './pages/admin/AddCourseTimeline';
import EditTestimonials from './pages/admin/EditTestimonials';
import AcademicCourses from './pages/PublicPages/AcademicCourses';

function App() {
  return (
    <Router>
      <AppProvider>
        <AuthProvider>
         <Layout>
  <Routes>


    {/* ---------- PUBLIC ROUTES ---------- */}
    <Route path="/" element={<Home />} />
    {/* <Route path="/ak" element={<AAAKKK />} /> */}
    <Route path="/login" element={<Home />} />
    <Route path="/all-courses" element={<AllCoursesPublic />} />
    <Route path="/academic" element={<AcademicCourses />} />
    <Route path="/email" element={<EmailForm />} />
    <Route path="/courses/:courseId" element={<CourseDetailsPage />} />

    
    <Route path="/service" element={<ServiceRoutes />} />
    <Route path="/portfolio-projects" element={<PortfolioP />} />

    {/* ---------- SHARED USER DASHBOARD ---------- */}
    <Route
      path="/user"
      element={
        <ProtectedRoute allowedRoles={['user', 'admin', 'prof']}>
          <AdminStudents />
        </ProtectedRoute>
      }
    />

    {/* ---------- ADMIN ROUTES ---------- */}
    <Route
      path="/admin-professors"
      element={
        <ProtectedRoute allowedRoles={['admin']}>
          <AdminProfessors />
        </ProtectedRoute>
      }
    />
    
    <Route
      path="/admin-students"
      element={
        <ProtectedRoute allowedRoles={['admin']}>
          <AdminStudents />
        </ProtectedRoute>
      }
    />

    <Route
      path="/free-courses"
      element={
        <ProtectedRoute allowedRoles={['admin']}>
          <AdminCourses />
        </ProtectedRoute>
      }
    />

    <Route
      path="/admin-control-timeline"
      element={
        <ProtectedRoute allowedRoles={['admin']}>
          <AddCourseTimeline />
        </ProtectedRoute>
      }
    />

    <Route
      path="/edit-feedback"
      element={
        <ProtectedRoute allowedRoles={['admin']}>
          <EditTestimonials />
        </ProtectedRoute>
      }
    />

    <Route
      path="/admin-courses-delete"
      element={
        <ProtectedRoute allowedRoles={['admin']}>
          <AdminCoursesDelete />
        </ProtectedRoute>
      }
    />

    <Route
      path="/add-portfolio"
      element={
        <ProtectedRoute allowedRoles={['admin']}>
          <AddPortfolio />
        </ProtectedRoute>
      }
    />

    <Route
      path="/edit-portfolio"
      element={
        <ProtectedRoute allowedRoles={['admin']}>
          <PortfolioList />
        </ProtectedRoute>
      }
    />

    <Route
      path="/edit-portfolio/:id"
      element={
        <ProtectedRoute allowedRoles={['admin']}>
          <AddPortfolio />
        </ProtectedRoute>
      }
    />

    {/* ---------- STUDENT ROUTES ---------- */}
    <Route
      path="/profile"
      element={
        <ProtectedRoute allowedRoles={['student','prof','admin']}>
          <ProfilePage />
        </ProtectedRoute>
      }
    />

    <Route
      path="/courses"
      element={
        <ProtectedRoute allowedRoles={['student','prof','admin']}>
          <MyCourses />
        </ProtectedRoute>
      }
    />

    {/* ---------- PROFESSOR ROUTES ---------- */}
    <Route
      path="/professor-courses"
      element={
        <ProtectedRoute allowedRoles={['prof']}>
          <ProfessorCourses />
        </ProtectedRoute>
      }
    />

     <Route
      path="/admin-student-enrolled"
      element={
        <ProtectedRoute allowedRoles={['prof']}>
          <ProfStudentsPage />
        </ProtectedRoute>
      }
    />

    {/* ---------- NOT FOUND ---------- */}
    <Route path="*" element={<NotFound />} />

  </Routes>
</Layout>

        </AuthProvider>
      </AppProvider>
    </Router>
  );
}

export default App;